import * as type from "./actionTypes";
import { defaultRequestGenerator, runGenerator } from "../common/requestActionHelper";

export const setTargetEmail = (targetEmail) => {
  return {
    type: type.SET_TARGET_EMAIL,
    payload: {
      targetEmail: targetEmail,
    },
  };
};

export const getMerchantsStart = () => {
  return {
    type: type.GET_MERCHANTS_START,
    payload: {
      isFetching: true,
    },
  };
};

export const getMerchantsSuccess = (data) => {
  return {
    type: type.GET_MERCHANTS_SUCCESS,
    payload: {
      isFetching: false,
      merchants: data,
      origin: data.url,
    },
  };
};

export const getMerchantsError = (err) => {
  return {
    type: type.GET_MERCHANTS_START,
    payload: {
      isFetching: false,
    },
    error: err,
  };
};

export const getAllMerchants = (host) => {
  return (dispatch) => {
    // eslint-disable-line
    const generator = defaultRequestGenerator({
      startAction: getMerchantsStart,
      successAction: getMerchantsSuccess,
      dispatch,
      requestObj: { url: host + "/v1/merchants" },
    });
    runGenerator(generator);
  };
};

export const getMerchants = (host, offset = 0, limit = 20, searchParam = 0) => {
  return (dispatch) => {
    // eslint-disable-line
    const generator = defaultRequestGenerator({
      startAction: getMerchantsStart,
      successAction: getMerchantsSuccess,
      dispatch,
      requestObj: {
        url:
          host +
          "/v1/merchants?limit=" +
          limit +
          "&offset=" +
          offset +
          "&status=active" +
          "&search_param=" +
          searchParam,
      },
    });
    runGenerator(generator);
  };
};

export const getMerchantDetails = (host, id) => {
  return (dispatch, getState) => {
    const state = getState();
    const merchants = state.get("impersonation").get("merchants");

    // has merchants state and merchant in list
    if (merchants) {
      const merchant = merchants
        .filter((m) => {
          return m.get("id") === id;
        })
        .first();
      if (merchant) {
        console.log(`Found merchant in state: ${id}`);
        dispatch(getMerchantDetailsSuccess(id, merchant));
        return;
      } else {
        console.log(`Did not find merchant ${id} in state`);
      }
    }

    // if not in merchants get merchant from service
    const generator = defaultRequestGenerator({
      successAction: (response) => {
        return getMerchantDetailsSuccess(id, response.data);
      },
      dispatch,
      requestObj: { url: `${host}/v1/merchants/${id}` },
    });

    runGenerator(generator);
  };
};

export const getMerchantDetailsSuccess = (id, merchant) => {
  return {
    type: type.GET_MERCHANT_DETAILS,
    payload: {
      id: id,
      merchant: merchant,
    },
  };
};

export const getUsersForMerchantStart = () => {
  return {
    type: type.GET_USERS_START,
    payload: {
      isFetching: true,
    },
  };
};

export const getUsersForMerchantError = (error) => {
  return {
    type: type.GET_USERS_ERROR,
    payload: {
      users: [],
      isFetching: false,
    },
    error: error,
  };
};

export const getUsersForMerchantSuccess = (data) => {
  return {
    type: type.GET_USERS_SUCCESS,
    payload: {
      users: data,
      isFetching: false,
    },
  };
};

export const getUsersForMerchant = (host, merchantId) => {
  return (dispatch) => {
    // eslint-disable-line
    const generator = defaultRequestGenerator({
      startAction: getUsersForMerchantStart,
      successAction: getUsersForMerchantSuccess,
      dispatch,
      requestObj: { url: `${host}/v1/merchants/${merchantId}/users` },
    });
    runGenerator(generator);
  };
};

export const setSearchParam = (searchParam) => {
  return {
    type: type.SET_SEARCH_PARAM,
    payload: {
      searchParam: searchParam,
    },
  };
};

export const getMerchantSource = (host, merchant_id) => {
  return (dispatch) => {
    const generator = defaultRequestGenerator({
      successAction: (response) => {
        return getMerchantSourceSuccess(response);
      },
      dispatch,
      requestObj: {
        url: `${host}/internal/v1/merchants/${merchant_id}/source`,
      },
    });

    runGenerator(generator);
  };
};

export const getMerchantSourceSuccess = (data) => {
  return {
    type: type.GET_MERCHANT_SOURCE_SUCCESS,
    payload: {
      source: data.source,
      source_id: data.source_id,
    },
  };
};
